/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { usageGetStripeCheckoutStatus } from "../funcs/usageGetStripeCheckoutStatus.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GetStripeCheckoutStatusResponseBody } from "../models/components/getstripecheckoutstatusresponsebody.js";
import {
  GetStripeCheckoutStatusRequest,
  GetStripeCheckoutStatusSecurity,
} from "../models/operations/getstripecheckoutstatus.js";
import { unwrapAsync } from "../types/fp.js";
export type GetStripeCheckoutStatusQueryData =
  GetStripeCheckoutStatusResponseBody;

export function prefetchGetStripeCheckoutStatus(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetStripeCheckoutStatusRequest,
  security?: GetStripeCheckoutStatusSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetStripeCheckoutStatusQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetStripeCheckoutStatusQuery(
  client$: GramCore,
  request: GetStripeCheckoutStatusRequest,
  security?: GetStripeCheckoutStatusSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GetStripeCheckoutStatusQueryData>;
} {
  return {
    queryKey: queryKeyGetStripeCheckoutStatus({
      sessionId: request.sessionId,
      gramSession: request.gramSession,
    }),
    queryFn: async function getStripeCheckoutStatusQueryFn(
      ctx,
    ): Promise<GetStripeCheckoutStatusQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(usageGetStripeCheckoutStatus(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetStripeCheckoutStatus(
  parameters: { sessionId: string; gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "usage", "getStripeCheckoutStatus", parameters];
}
